import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { Question } from '@models/recruiting/question.model';

@Component({
    selector: 'app-job-posting-store-questions-information',
    templateUrl: './job-posting-store-questions.form.html',
    styleUrls: ['./job-posting-store-questions.style.scss'],
})
export class JobPostingStoreQuestionsForm extends BaseForm {
    @Input() jobPosting: JobPosting = new JobPosting();
    @Input() hasQuickApply: boolean = false;
    @Input() hasConsentFlag: boolean = false;
    @Input() autoArchivingQuestions: Question[] = [];
    @Input() additionalQuestions: Question[] = [];
    @Output() refreshData = new EventEmitter();

    autoArchivingQuestion: Question = new Question();
    additionalQuestion: { label: string; type: 'input' | 'number' | 'textarea' | 'date'; required: boolean } = {
        label: '',
        type: 'input',
        required: false,
    };
    isAdditionalQuestionDialogOpen = false;

    constructor(private element: ElementRef) {
        super();
    }

    /**
     * Attach the question to the job posting and clear the form
     */
    onAddAutoArchivingQuestion(): void {
        if (!this.autoArchivingQuestion.question) {
            return;
        }

        this.autoArchivingQuestion.isAutoArchive = true;
        this.autoArchivingQuestion.isRequired = true;

        this.jobPosting.temporaryAutoArchivingQuestions.push(this.autoArchivingQuestion);

        this.autoArchivingQuestion = new Question();
    }

    onDeleteAutoArchivingQuestion(questionIndex: number): void {
        this.jobPosting.temporaryAutoArchivingQuestions = this.jobPosting.temporaryAutoArchivingQuestions.filter(
            (_question, index) => questionIndex !== index
        );
    }

    /**
     * Attach the question to the job posting and clear the form
     */
    onAddAdditionalQuestion(): void {
        if (!this.additionalQuestion.label) {
            return;
        }

        if (!this.jobPosting.additionalQuestions) {
            this.jobPosting.additionalQuestions = [];
        }

        this.jobPosting.additionalQuestions.push(this.additionalQuestion);

        this.additionalQuestion = {
            label: '',
            type: 'input',
            required: false,
        };

        $(this.element.nativeElement).find('.ui.dropdown').dropdown('set selected', 'input');
    }

    onDeleteAdditionalQuestion(questionIndex: number): void {
        this.jobPosting.additionalQuestions = this.jobPosting.additionalQuestions.filter(
            (_question, index) => questionIndex !== index
        );
    }
}
